import { useAuth } from '../hooks/useAuth';

export default function Settings() {
  const { user } = useAuth();

  const card = { background: '#fff', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '12px', padding: '1.25rem', marginBottom: '12px' };
  const inp = { width: '100%', padding: '8px 10px', border: '0.5px solid #ddd', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box', background: '#f5f4f0' };
  const label = { display: 'block', fontSize: '11px', fontWeight: '500', color: '#666', marginBottom: '4px' };

  const trialEnds = user?.trial_ends_at ? new Date(user.trial_ends_at) : null;
  const trialDaysLeft = trialEnds ? Math.max(0, Math.ceil((trialEnds - new Date()) / 86400000)) : 0;
  const isActive = user?.subscription_status === 'active';
  const isTrial = user?.subscription_status === 'trial' || !user?.subscription_status;

  return (
    <div>
      <div style={card}>
        <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '1rem' }}>Account</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          <div>
            <label style={label}>Name</label>
            <input style={inp} value={user?.name || ''} readOnly />
          </div>
          <div>
            <label style={label}>Email</label>
            <input style={inp} value={user?.email || ''} readOnly />
          </div>
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '1rem' }}>Subscription</div>
        {isTrial && (
          <div style={{ background: '#FAEEDA', border: '0.5px solid #F5DFA8', borderRadius: '8px', padding: '14px 16px', marginBottom: '1rem' }}>
            <div style={{ fontSize: '13px', fontWeight: '500', color: '#854F0B' }}>
              🕐 Free trial — {trialDaysLeft} days remaining
            </div>
            <div style={{ fontSize: '12px', color: '#854F0B', marginTop: '4px' }}>
              Your trial ends on {trialEnds ? trialEnds.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : 'soon'}
            </div>
          </div>
        )}
        {isActive && (
          <div style={{ background: '#EAF3DE', border: '0.5px solid #B8DFA8', borderRadius: '8px', padding: '14px 16px', marginBottom: '1rem' }}>
            <div style={{ fontSize: '13px', fontWeight: '500', color: '#27500A' }}>
              ✅ SellerDash Pro — Active
            </div>
            <div style={{ fontSize: '12px', color: '#3B6D11', marginTop: '4px' }}>
              £10/month · Your subscription is active
            </div>
          </div>
        )}
        {isTrial && (
          <button style={{ background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '8px', padding: '9px 18px', fontSize: '13px', cursor: 'pointer' }}>
            Upgrade to Pro — £10/month
          </button>
        )}
      </div>

      <div style={card}>
        <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '1rem' }}>Your plan includes</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          {[
            'Real-time Amazon data sync',
            'Profit & VAT calculator',
            'Inventory management',
            'Reorder alerts + email notifications',
            'BSR tracker',
            'Shipment ETA calculator',
            'P&L reports (daily to annual)',
            'Payout tracking',
          ].map(f => (
            <div key={f} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#555' }}>
              <span style={{ color: '#1D9E75', fontWeight: '600' }}>✓</span>
              {f}
            </div>
          ))}
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '1rem' }}>Help & support</div>
        <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.7' }}>
          Need help? Email us at <a href="mailto:support@knotyourtype.co.uk" style={{ color: '#378ADD' }}>support@knotyourtype.co.uk</a>
        </div>
      </div>
    </div>
  );
}